

































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import BottomScores from '@/components/activity/BottomScores.vue';
import { RapidTestResponse } from '@/store/types';

export default Vue.extend({
  components: {
    activity: Activity,
    'activity-status': ActivityStatus,
    'bottom-scores': BottomScores,
  },
  props: ['videoPlayer', 'quizPhrase', 'activityIndex', 'activityDataLength', 'averageScore'],
  data() {
    return {
      hidePhraseActivity: true,
    };
  },
  mounted() {
    this.hidePhraseActivity = true;
  },
  methods: {
    async onScoreResult(score: number, nextQuestionResponse: RapidTestResponse) {
      this.$emit('onScoreResult', score);
      this.hidePhraseActivity = false; // this is for not answering twice
      if (this.$refs.activityStatus) {
        (this.$refs.activityStatus as any).updateScore(score, '');
      }
      await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
      if (this.$refs.activity) {
        (this.$refs.activity as any)
          .startPlaying(nextQuestionResponse && nextQuestionResponse.data.previous_qz_answer);
      }
    },
    audioPlayed(nextQuestionResponse: RapidTestResponse) {
      if (!this.hidePhraseActivity) {
        this.hidePhraseActivity = true;
        this.$emit('checkQuizEndOrNext', nextQuestionResponse);
      }
    },
    onActivityStopped() {
      this.hidePhraseActivity = true;
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
  },
});
